<div class="row">
    <div class="col-12 ">
        <label for="url" class="form-label">Url</label>
        <input type="text" class="form-control" id="url" name="url" ngModel #url="ngModel" [(ngModel)]="authConfig.url"
            required />
    </div>
     <div class="col-12 ">
        <label for="url" class="form-label">PTZ Url</label>
        <input type="text" class="form-control" id="url" name="url" ngModel #url="ngModel" [(ngModel)]="authConfig.ptzUrl"
            required />
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Username</label>
        <input type="text" class="form-control" id="username" name="username" ngModel #name="ngModel"
            [(ngModel)]="authConfig.username" required />
    </div>
    <div class="col-md-6 ">
        <label for="name" class="form-label">Password</label>
        
        <div class="input-group">
            <input type="{{ showPassword ? 'text' : 'password' }}" class="form-control" id="password" name="password"
            ngModel #name="ngModel" [(ngModel)]="authConfig.password" required />
            <button type="button" class="btn btn-outline-secondary" (click)="showPassword = !showPassword"
                tabindex="-1">
                <i   [ngClass]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
        </div>
    </div> 
 
</div>